import { useTranslation } from '@/i18n/client'
import { useEffect } from 'react'
import { useAppSelector } from 'store'

export const CompanyTranslationLoader = () => {
  const companyId = useAppSelector(state => state.company.id)
  const { i18n } = useTranslation()

  useEffect(() => {
    const id = setTimeout(() => {
      if (!companyId) {
        i18n.setDefaultNamespace('tucan')
        return
      }

      i18n.setDefaultNamespace(`company-${companyId}`)
      // i18n.loadResources() // no need to trigger load as it is done automatically
    }, 50)

    return () => clearTimeout(id)
  }, [companyId])

  return null
}
